const EventEmitter = require('events').EventEmitter
const eventEmitter = new EventEmitter()

export default {
    event: eventEmitter,
    name:'api.biomedia.net',
    version: '2604.001',
    urlsite: document.location.origin+'/bams/',
    app: document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1, 
    uuid: '0123456789',
    onesignal: 'non disponibile',
    platform: (document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1) ? 'app' : 'desktop',
    online: true,
    innerHeight: window.innerHeight,
    screenHeight: screen.height,
    height: window.innerHeight,
    width: screen.width,
    pixelRatio: window.devicePixelRatio,

    appReady: false,
    routeInitial: '/',

    minutes: 0,
    language:'it',
    lang:{},
    en:{},
    it:{},

    chiuso:false,
    preview: false,
    absInviato: false,

    evento:{},
    bvent:{},
    topicposter:{},
    topiccomunicazione:{},
    categoriaprofessionale:{},
    nazionelavoro:{},
    regionelavoro:{},
    associazioni: {},
    

    abs:{},
    affiliazioni:[],
    autori:[],

    sostituisci: function(cosa){
        return this.lang[cosa]
    },

    random: function() {
        return Math.floor((Math.random() * 10000) + 1)
    }
}



// WEBPACK FOOTER //
// ./src/teras.js